import { render, staticRenderFns } from "./UsStep5.vue?vue&type=template&id=04d351e7"
import script from "./UsStep5.vue?vue&type=script&lang=js"
export * from "./UsStep5.vue?vue&type=script&lang=js"
import style0 from "./UsStep5.vue?vue&type=style&index=0&id=04d351e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports